import OptimizedImage from "@/components/OptimizedImage";
import { GradientText } from "@/components/ui/gradient-text";
import { SimpleReveal } from "@/hooks/useSimpleAnimation";

interface Hero1Props {
  heading: string;
  description: string;
  image: {
    src: string;
    alt: string;
  };
}

const Hero1 = ({
  heading,
  description,
  image
}: Hero1Props) => {
  const renderHeading = () => {
    // Desktop: Create specific 4-line layout, Mobile: Natural flow with proper spacing
    return <>
       <span className="inline md:whitespace-nowrap">The pharmaceutical industry </span><br className="hidden md:block" />
       <span className="inline md:whitespace-nowrap">needs better oral delivery solutions </span><br className="hidden md:block" />
       <span className="inline md:whitespace-nowrap">for poorly water‑soluble drugs </span><br className="hidden md:block" />
       <span className="inline md:whitespace-nowrap">and biopharmaceuticals</span>
    </>;
  };

  return (
    <section className="relative bg-white overflow-hidden pt-2 md:pt-20 lg:pt-28 pb-6 md:pb-20 lg:pb-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Mobile/Tablet: Stack vertically, Desktop: Side by side */}
        <div className="grid grid-cols-1 lg:grid-cols-[1.2fr_1fr] gap-8 lg:gap-6 xl:gap-7 2xl:gap-8 items-start lg:items-center">
          
          {/* Text Content */}
          <SimpleReveal>
            <div className="order-2 lg:order-1">
              <div className="space-y-6 text-center lg:text-left max-w-2xl lg:max-w-none mx-auto lg:mx-0">
                <h1 className="text-neutral-900 leading-tight font-semibold tracking-tight text-2xl sm:text-3xl md:text-4xl lg:text-4xl xl:text-5xl 2xl:text-6xl break-words">
                  {renderHeading()}
                </h1>
                <GradientText
                  colors={["hsl(var(--color-1))", "hsl(var(--color-2))", "hsl(var(--color-3))", "hsl(var(--color-4))", "hsl(var(--color-5))", "hsl(var(--color-1))", "hsl(var(--color-2))", "hsl(var(--color-3))", "hsl(var(--color-4))", "hsl(var(--color-5))", "hsl(var(--color-1))", "hsl(var(--color-2))"]}
                  animationSpeed={18}
                  className="font-semibold leading-tight text-2xl sm:text-3xl md:text-4xl lg:text-3xl xl:text-4xl 2xl:text-5xl"
                >
                  {description}
                </GradientText>
              </div>
            </div>
          </SimpleReveal>
          
          {/* Image */}
          <SimpleReveal>
            <div className="order-1 lg:order-2 flex justify-center lg:justify-end">
              <div className="w-full max-w-lg sm:max-w-xl md:max-w-2xl lg:max-w-2xl xl:max-w-3xl 2xl:max-w-4xl aspect-[4/3]">
                <OptimizedImage 
                  src={image.src} 
                  alt={image.alt} 
                  className="w-full h-full object-contain drop-shadow-xl" 
                  sizes="(max-width: 767px) 90vw, (max-width: 1023px) 80vw, 50vw"
                  priority={true} 
                />
              </div>
            </div>
          </SimpleReveal>

        </div>
      </div>
    </section>
  );
};
export { Hero1 };